import { render, staticRenderFns } from "./xwDetail.vue?vue&type=template&id=2e9e3130&"
import script from "./xwDetail.vue?vue&type=script&lang=js&"
export * from "./xwDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports